export default "__VITE_ASSET__XgCYGEqT__"